import {getSearchTerm} from 'helpers/string'
import {get, isEmpty} from 'lodash'

export const getReceivedNotInvoicedParams = (
    search,
    statusTypes,
    companies,
    raisedBy,
    dateTypes,
    targetStart,
    targetEnd,
    printedEmailed,
    notInvoiced) => {

    const params = {}

    if (getSearchTerm(search))
        params['search'] = search

    params['status'] = statusTypes

    if (!isEmpty(companies))
        params['companyId'] = companies.map(company => company.value)

    if (!isEmpty(raisedBy))
        params['creatorId'] = raisedBy.map(raisedBy => raisedBy.value)

    if (!isEmpty(printedEmailed))
        params['printedEmailed'] = printedEmailed

    if (targetStart && targetEnd) {
        dateTypes.forEach(dateType => {
            params[`${dateType}Start`] = targetStart
            params[`${dateType}End`] = targetEnd
        })
    }

    params['notInvoiced'] = notInvoiced
    params.total = true
    return params
}

export const getReceivedNotInvoicedValue = (purchaseOrder) => {
    if (purchaseOrder === null) return 0
    const received = get(purchaseOrder, 'receivedValue', 0)
    const invoiced = get(purchaseOrder, 'totalInvoiced', 0)
    return received > invoiced ? received - invoiced : 0
}